import axios from 'axios';

export default {
    async getPermissionLevel () {
        return (await axios.get('/api/auth/')).data;
    },
};